import { OBSTACLE_TYPE } from "./../ENUM.js";
import * as SOUND_DATA from "./../SOUND_DATA.js";

export const MULT2 = {
  isDark: true,
  startHealth: 20,
  timeAllowedSecs: 80,
  textColor: "#ffaaaa",
  textColorHighlight: "#aaaaff",
  bgColor: "#000000",
  bgFadeAlpha: 0.45,
  gameplayAreaToCanvasLateralRatio: 0.4,
  controllerSpeedDamp: 10,
  player: {
    color: "#ffffff",
    growthDivisor: 500,
    radius: 15,
  },
  obstacles: [
    {
      type: OBSTACLE_TYPE.BACKGROUND,
      total: 600,
      color_ar: [
        "#7366ff",
        "#b66e00",
        "#b67e4b",
        "#645716",
        "#e12500",
        "#a7222e",
        "#559950",
        "#c2709c",
        "#01744c",
        "#5d7600",
        "#f14d7e",
        "#a12751",
        "#0067be",
        "#5741c0",
        "#9b00a4",
        "#d66a5f",
      ],
      radiusRange: [1, 2],
      directionRange: [90, 270],
      speedRange: [0.003, 0.009],
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      collectSfx_ar: SOUND_DATA.ORDERED_DROP_SFX_AR,
      total: 300,
      color_ar: [
        "#7366ff",
        "#b66e00",
        "#b67e4b",
        "#645716",
        "#e12500",
        "#a7222e",
        "#559950",
        "#c2709c",
        "#01744c",
        "#5d7600",
        "#f14d7e",
        "#a12751",
        "#0067be",
        "#5741c0",
        "#9b00a4",
        "#d66a5f",
      ],
      radiusRange: [16, 19],
      directionRange: [120, 240],
      speedRange: [1, 3],
      // 0.01 - 0.99
      gradientFadePoint: 0.01,
    },
    {
      type: OBSTACLE_TYPE.AVOID,
      total: 3,
      color_ar: ["#191919"],
      radiusRange: [60, 70],
      directionRange: [120, 240],
      speedRange: [1, 2],
    },
  ],
};
